import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from '@emotion/styled';

const ListadoIconos = styled.ul`
    display: flex;
    justify-content: space-between;
    flex: 1;
    max-width: 500px;
    margin: 0 auto 0 auto;

    @media( max-width: 425px){
        margin: 0 auto 0 auto;
    }

    li {
        display: flex;
        padding: 1rem;
        img {
            margin-right: 1rem;
        }

        @media( max-width: 425px){
        padding: 0.5rem;

        img {
            margin-right: 0.3rem;
        }

    }

    @media( max-width: 320px){
        padding: 0.7rem;

    }
    }
`;

const Iconos = ({ wc, estacionamiento, habitaciones }) => {

    const { iconos } = useStaticQuery(graphql`
    query {
        iconos: allFile(filter: { relativeDirectory: {eq: "iconos"}}){
            edges{
                node{
                id
                publicURL
      }
      }
      }
    }
    `)


    const imagenesIconos = iconos.edges;
    return (
        <ListadoIconos>
            <li>
                <img src={imagenesIconos[2].node.publicURL} alt="iconos wc" />
                <p>{wc}</p>
            </li>
            <li>
                <img src={imagenesIconos[4].node.publicURL} alt="iconos estacionamiento" />
                <p>{estacionamiento}</p>
            </li>
            <li>
                <img src={imagenesIconos[5].node.publicURL} alt="iconos habitaciones" />
                <p>{habitaciones}</p>
            </li>
        </ListadoIconos>
    );
}

export default Iconos;